import axiosInstance from './axiosInstance';
import { DailyAttendance, CreateDailyAttendanceDto, UpdateDailyAttendanceDto } from '../types/dailyAttendance.types';

const API_URL = 'DailyAttendance';

export const dailyAttendanceService = {
  getAll: async (): Promise<DailyAttendance[]> => {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  },

  getByDate: async (date: string, branchId?: number): Promise<DailyAttendance[]> => {
    const params: any = { date };
    if (branchId !== undefined) {
      params.branchId = branchId;
    }
    const response = await axiosInstance.get(`${API_URL}`, { params });
    return response.data;
  },

  create: async (data: CreateDailyAttendanceDto): Promise<DailyAttendance> => {
    const response = await axiosInstance.post(API_URL, data);
    return response.data;
  },

  update: async (id: number, data: UpdateDailyAttendanceDto): Promise<DailyAttendance> => {
    const response = await axiosInstance.put(`${API_URL}/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },
};